import React from 'react';

const ProgressBarTabs = ({ steps = [], activeStep = 1, onStepClick }) => {
  return (
    <div className="w-full max-w-lg mx-auto px-8 p-b">
      <div className="relative">
        {/* Progress Line Background */}
        <div className="absolute top-6 left-10 right-10 h-0.5 bg-gray-200">
          {/* Active Progress Line */}
          <div
            className={`h-full bg-blue-600 transition-all duration-500 ease-out ${
              activeStep >= steps.length
                ? 'w-full'
                : `w-[${((activeStep - 1) / (steps.length - 1)) * 100}%]`
            }`}
            style={{
              width:
                steps.length > 1
                  ? `${((activeStep - 1) / (steps.length - 1)) * 100}%`
                  : '0%',
            }}
          />
        </div>

        {/* Steps Container */}
        <div className="relative flex justify-between">
          {steps.map((label, idx) => {
            const stepNum = idx + 1;
            const isActive = activeStep === stepNum;
            const isCompleted = activeStep > stepNum;

            return (
              <div
                key={stepNum}
                className="flex flex-col items-center cursor-pointer"
                onClick={() => {
                  if (onStepClick && !isActive) onStepClick(idx);
                }}
                style={{ pointerEvents: isActive ? 'none' : 'auto' }}
              >
                {/* Step Circle */}
                <div
                  className={`
                  relative rounded-full border-2 flex items-center justify-center
                  transition-all duration-300 ease-out
                  ${
                    isActive
                      ? 'w-12 h-12 bg-white border-blue-600 shadow-lg shadow-blue-200'
                      : isCompleted
                        ? 'w-10 h-10 bg-blue-600 border-blue-600'
                        : 'w-10 h-10 bg-white border-gray-300 hover:border-gray-400'
                  }
                `}
                >
                  {isActive ? (
                    <div className="w-8 h-8 bg-blue-600 rounded-full" />
                  ) : isCompleted ? (
                    <svg
                      className="w-5 h-5 text-white"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  ) : (
                    <span
                      className={`text-sm font-medium ${
                        isActive ? 'text-white' : 'text-gray-500'
                      }`}
                    >
                      {stepNum}
                    </span>
                  )}
                </div>

                {/* Step Label */}
                <div className="mt-3 text-center">
                  <span
                    className={`
                    text-sm font-medium transition-colors duration-200
                    ${
                      isActive
                        ? 'text-blue-700'
                        : isCompleted
                          ? 'text-gray-700'
                          : 'text-gray-500'
                    }
                  `}
                  >
                    {label}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ProgressBarTabs;
